import type {
    MatPartReviewRow,
    MatReviewAggregatedGroupData,
    MatReviewLevelStatisticsTreeSerializer,
    PpvLevelStatisticsTreeSerializer
} from "./MaterializedClasses";
import {MatPartReviewRowState} from "./MaterializedClasses";

/**
 * The part can be selected for review and the category can be changed
 * @param row
 */
export function isReviewRowOpenForReview(row: Pick<MatPartReviewRow, 'state'>): boolean {
    return row.state !== MatPartReviewRowState.pending
}

export function countReviewGroupOpenForReview(group: MatReviewAggregatedGroupData) {
    return group.count - group.n_pending_agg;
}

export function countReviewGroupClosedForReview(group: MatReviewAggregatedGroupData) {
    return group.n_pending_agg;
}

/**
 * The part can is open for review and can be accepted directly
 * @param row
 */
export function isReviewRowAcceptable(row: Pick<MatPartReviewRow, 'state' | 'cat'>): boolean {
    // See backend: m_review.base_review.queryset.MatPartReviewRowQS.q_is_open_uncat
    if (row.state === MatPartReviewRowState.pending) return false;
    if (!row.cat) {
        console.warn('Row has no category set', row);
        return true;
    }
    return row.cat.id !== 1; // Category != 'Uncategorized'
}

export function countReviewRowNotAcceptable(group: MatReviewAggregatedGroupData) {
    return group.n_is_open_uncat_agg;
}

export function selectMatReviewLevelStatistics(tree: MatReviewLevelStatisticsTreeSerializer, categorySelection: string[]): MatReviewLevelStatisticsTreeSerializer[] {
    const result = [tree]
    if (!categorySelection) return result;
    for (const category of categorySelection) {
        const parent = result.at(-1) as MatReviewLevelStatisticsTreeSerializer;
        const node = parent.children.find(n => n.label === category)
        if (!node) {
            throw new Error(`Cannot find category ${categorySelection} in tree`)
        }
        result.push(node);
    }
    return result;
}

export function selectPpvLevelStatistics(tree: PpvLevelStatisticsTreeSerializer, categorySelection: string[]): PpvLevelStatisticsTreeSerializer[] {
    const result = [tree]
    if (!categorySelection) return result;
    for (const category of categorySelection) {
        const parent = result.at(-1) as PpvLevelStatisticsTreeSerializer;
        const node = parent.children.find(n => n.label === category)
        if (!node) {
            throw new Error(`Cannot find category ${categorySelection} in tree`)
        }
        result.push(node);
    }
    return result;
}
